
<div class="OfflineIndicator">
  <div class="OfflineIndicator_Inner" v-if="isOffline">
    Offline. Your changes will sync when you reconnect.
  </div>
  <div
    class="OfflineIndicator_Inner m-online"
    v-if="!isOffline && !$store.state.isInIframe"
  >
    Changes are saved automatically
  </div>
</div>
